var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_991_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.25C29.6062 11.25 35.9437 15.2438 39.0375 21.5625C35.9437 27.8812 29.6062 31.875 22.5 31.875C15.3938 31.875 9.05625 27.8812 5.9625 21.5625C9.05625 15.2438 15.3938 11.25 22.5 11.25ZM22.5 7.5C13.125 7.5 5.11875 13.3313 1.875 21.5625C5.11875 29.7937 13.125 35.625 22.5 35.625C31.875 35.625 39.8812 29.7937 43.125 21.5625C39.8812 13.3313 31.875 7.5 22.5 7.5ZM22.5 16.875C25.0875 16.875 27.1875 18.975 27.1875 21.5625C27.1875 24.15 25.0875 26.25 22.5 26.25C19.9125 26.25 17.8125 24.15 17.8125 21.5625C17.8125 18.975 19.9125 16.875 22.5 16.875ZM22.5 13.125C17.85 13.125 14.0625 16.9125 14.0625 21.5625C14.0625 26.2125 17.85 30 22.5 30C27.15 30 30.9375 26.2125 30.9375 21.5625C30.9375 16.9125 27.15 13.125 22.5 13.125Z",
    fill: "#AD6E6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_991_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisao);
export default __webpack_public_path__ + "static/media/Visao.b633211cb6695483003de37b1a318372.svg";
export { ForwardRef as ReactComponent };